import { C } from "../ui/theme.ts";

/**
 * Semáforo de cumplimiento — los 4 estados que calcula el motor de captura.
 * Es lo ÚNICO que el plano de ventas ve del motor de riesgo (sin scores ni jerga).
 * Colores del semáforo único del sistema de diseño (ui/theme.ts) — antes tenía
 * su propio juego de verde/ámbar/rojo distinto al del plano REC (issue #47).
 */
export type EstadoSemaforo = "verde" | "ambar" | "rojo" | "gris";

const ESTILO: Record<EstadoSemaforo, { color: string; etiqueta: string }> = {
  verde: { color: C.green, etiqueta: "Sigue" },
  ambar: { color: C.amber, etiqueta: "El REC revisa" },
  rojo: { color: C.red, etiqueta: "No se puede aplicar (abstención)" },
  gris: { color: C.muted, etiqueta: "Requiere revisión del REC" },
};

export function Semaforo({ estado }: { estado: EstadoSemaforo }) {
  const s = ESTILO[estado];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <span
        aria-hidden
        style={{
          width: 14,
          height: 14,
          borderRadius: "50%",
          background: s.color,
          display: "inline-block",
        }}
      />
      <span style={{ fontSize: 14 }}>{s.etiqueta}</span>
    </span>
  );
}
